<lib-document-checklist-new-library [primaryData]="primaryData" [disabledControls]="disabledControls"></lib-document-checklist-new-library>

<!-- <form #organizeDocumentsForm="ngForm">
    <div class="row title">
        <div class="col-md-10 d-flex align-items-center">
            <h6>Re-arrange The Sections & Documents</h6>
        </div>
        <div class="col-md-2">
            <button pButton type="button" label="Reset" (click)="resetOrganizedDocument()" [disabled]="disabledControls"
                class="p-button-outlined"></button>
        </div>
    </div>
    <div class="pl-3">
        <p-tree [value]="supportingDocumentsTree" [draggableNodes]="true" [droppableNodes]="true" draggableScope="self"
            [validateDrop]="true" (onNodeDrop)="onDrop($event)" droppableScope="self">
            <ng-template let-node pTemplate="parent">
                <div class="row mt-3 mb-2">
                    <div class="col-10 pl-0">
                        <p-inplace *ngIf="node.class != 'custom'" #inplace closable="closable"
                            [style]="{'min-height':'33px'}" class="titleSheet">
                            <ng-template pTemplate="display">
                                <div class="d-inline"> <strong>{{node.data.titleSheetName}}</strong></div>
                            </ng-template>
                        </p-inplace>
                        <p-inplace *ngIf="node.class == 'custom'" #inplaceCustom closable="closable"
                            [style]="{'min-height':'33px'}" class="titleSheet">
                            <ng-template pTemplate="display">
                                <div class="d-inline"> <strong>{{node.data.categoryName}}</strong></div>
                            </ng-template>
                            <ng-template pTemplate="content">
                                <input type="text" [(ngModel)]="node.data.categoryName" pInputText>
                                <button pButton type="button" label="Save" class="ml-2 button-success"
                                    (click)="renameCustomTitleSheet($event)"></button>
                            </ng-template>
                        </p-inplace>
                    </div>
                    <div class="col-2" *ngIf="!disabledControls" style="cursor: pointer;" pTooltip="Drag & Drop">
                        <div *ngIf="node.class != 'custom'" class="text-right">
                            <i class="fa fa-ellipsis-v text-secondary" aria-hidden="true"></i>
                            <i class="fa fa-ellipsis-v text-secondary ml-0 mr-4" aria-hidden="true"></i>
                        </div>
                    </div>
                </div>
                <div class="p-datatable p-datatable-header border mt-3 ml-n4" style="width:100.9%">
                    <div class="p-datatable-thead">
                        <tr style="min-width: 100%;display: inline-table;">
                            <th style="width:40%">Document Type</th>
                            <th style="width:40%">Document Name</th>
                            <th><span class="ml-3">Action</span></th>
                        </tr>
                    </div>
                    <div *ngIf="node.class == 'custom' && node.children.length == 0" class="p-datatable-tbody">
                        <tr>
                            <td><small class="text-secondary">Drag & Drop related documents to this title sheet.</small>
                            </td>
                        </tr>
                    </div>
                </div>
            </ng-template>
            <ng-template let-childNode pTemplate="child">
                <div class="p-datatable">
                    <div class="p-datatable-tbody" *ngFor="let singleDoc of childNode.data.documents;let i=index">

                       
                        <div *ngIf="i > 0" class="border"></div>
                        <tr class="d-flex align-items-center">
                            <td style="width:40%">{{childNode.data.fileCategoryCode === 'OTHER'?
                                singleDoc.fileCtaegoryOtherName : childNode.data.docName}}
                                <span *ngIf="(childNode.data.isGenerated != null) && (childNode.data.isGenerated)" style="font-style: italic; font-size: 11px; color: #cecece;"><b>(System Generated)</b></span>
                                <span *ngIf="(childNode.data.isGenerated != null) && !(childNode.data.isGenerated)" style="font-style: italic; font-size: 11px; color: #cecece;"><b>(Manual Uploaded)</b></span>
                            </td>
                            <td style="width:40%">



                                <span *ngIf="singleDoc.uploadedFileName != null">
                                    {{singleDoc.uploadedFileName}}</span>

                                    <span *ngIf="singleDoc.uploadedFileName == null">
                                        {{singleDoc.fileName}}</span>
                            </td>
                            <td>
                                <span class="align-top">
                                    <button pButton type="button" (click)="viewDocument(singleDoc.fileLocation)"
                                        icon="pi pi-eye" pTooltip="View"
                                        class="p-0 p-button-icon-only bg-white border-0 text-secondary d-inline">
                                    </button>
                                </span>
                                <div class="d-inline pl-1" *ngIf="!disabledControls" style="cursor: pointer;"
                                    pTooltip="Drag & Drop">
                                    <i class="fa fa-ellipsis-v text-secondary" aria-hidden="true"></i>
                                    <i class="fa fa-ellipsis-v text-secondary ml-0 mr-2" aria-hidden="true"></i>
                                </div>
                            </td>
                        </tr>
                    </div>
                </div>
            </ng-template>
        </p-tree>
        <hr /> 
        <button type="button" [disabled]="disabledControls"
            [ngClass]="disabledControls ? 'btn-success button-width-icon-left mr-3 pl-4 pr-4 btn-success_disabled':'btn-success button-width-icon-left mr-3 pl-4 pr-4'"
            pButton (click)="postOrganizedDocument();" label="Save"></button>
        <p-confirmDialog header="Delete"></p-confirmDialog>
    </div>
</form> -->